import {DevicePropertyNames} from '@webmate-web-core/shared/types/devices/device-properties';

// Sensor Simulation
export const SimulateBiometrics = DevicePropertyNames.SimulateBiometrics;
export const AcceptBiometricAuthentication = DevicePropertyNames.BiometricAuthentication;
export const SimulateCamera = DevicePropertyNames.SimulateCamera;
